import store from '../store';

const errors = (state = [], action) => {

	switch (action.type) {

		case 'REMOVE_ERROR': {

			const { message, type } = action.options;

			const currentErrors = state[type] ? state[type] : null;

			const set = new Set(currentErrors).delete(message);

			const newErrors = Array.from(set);

			return {
				...state,
				[type]: newErrors
			};
		}

		case 'ADD_ERROR': {

			const { message, type, timeout } = action.options;

			const currentErrors = state[type] ? state[type] : null;

			const set = new Set(currentErrors).add(message);

			const newErrors = Array.from(set);

			setTimeout(() => {

				store.dispatch({ type: 'REMOVE_ERROR', options: { message, type } });

			}, timeout);

			return {
				...state,
				[type]: newErrors
			};
		}

		default:
			return state;
	}
}
export default errors;



// WEBPACK FOOTER //
// ./src/reducers/errors.js